import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { defaultTransactionData, updateTransaction, getTransactionById } from '@/api/transactions';
import { getOrderById } from '@/api/order';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultTransactionData);
    this.loading = false;
    this.order = null;
    this.payableAmount = 0;
    this.rules = {
      utrNumber: {
        required: true,
        trigger: 'blur',
        message: 'Please enter utr number'
      },
      amount: {
        required: true,
        trigger: 'blur',
        message: 'Please enter transaction amount'
      },
      transactionDate: {
        required: true,
        trigger: 'blur',
        message: 'Please enter transaction date'
      },
      bank: {
        required: true,
        trigger: 'blur',
        message: 'Please enter bank name'
      }
    };
    this.statusOptions = [{
      label: 'Success',
      key: 'success'
    }, {
      label: 'Failure',
      key: 'failure'
    }];
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    const id = this.$route.params && this.$route.params.id;
    this.fetchData(parseInt(id));
    this.formData = Object.assign({}, defaultTransactionData);
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getTransactionById(id);
      this.formData = data;
      await this.getOrderInfo(data.orderId);
      // Just for test
      const title = 'Approve RTGS';
      // // Set tagsview title
      this.setTagsViewTitle(title);
      // // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getOrderInfo(orderId) {
    try {
      this.order = await getOrderById(orderId);
      if (this.order) {
        this.payableAmount = +this.order.grandTotal - +this.order.amountReceived;
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  isDateAllowed(time) {
    return time.getTime() > Date.now();
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      await updateTransaction(this.formData.id, this.formData);
      this.$notify({
        title: 'Success',
        message: 'RTGS approved ',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      router.push(`/transaction/list/${this.formData.orderId}`);
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'RTGSDetail',
  components: {}
})], default_1);
export default default_1;